// const [deviceFormData, setDeviceFormData] = React.useState({
//     brand: "",
//     company: "",
//     dataProtocol: "",
//     description: "",
//     id: "",
//     model: "",
//     password: "",
//     software: "",
//     softwareVersion: "",
//     status: "ACTIVE",
// });

export const simcard_fields = () => [
  {
    key: 'iccid',
    type: 'text',
    inputType: 'text',
    placeHolder: 'ICC ID*',
    defaultValue: '',
  },
  {
    key: 'status',
    type: 'select',
    items: [
      { value: 'ACTIVE', text: 'Aktif' },
      { value: 'INACTIVE', text: 'Pasif' },
    ],
    placeHolder: 'Durum*',
    defaultValue: 'ACTIVE',
  },
  {
    key: 'barcodeNumber',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Barkod Numarası',
    defaultValue: '',
  },
  {
    key: 'operator',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Operatör',
    defaultValue: '',
  },
  {
    key: 'sim1',
    type: 'text',
    inputType: 'text',
    placeHolder: 'SIM 1 Kodu',
    defaultValue: '',
  },
  {
    key: 'sim2',
    type: 'text',
    inputType: 'text',
    placeHolder: 'SIM 2 Kodu',
    defaultValue: '',
  },
  {
    key: 'puk1',
    type: 'text',
    inputType: 'text',
    placeHolder: 'PUK 1 Kodu',
    defaultValue: '',
  },
  {
    key: 'puk2',
    type: 'text',
    inputType: 'text',
    placeHolder: 'PUK 2 Kodu',
    defaultValue: '',
  },

  // {
  //   key: 'brand',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Marka',
  //   defaultValue: '',
  // },
  // {
  //   key: 'company',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Şirket',
  //   defaultValue: '',
  // },
  // {
  //   key: 'description',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Açıklama',
  //   defaultValue: '',
  // },
  // {
  //   key: 'model',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Model',
  //   defaultValue: '',
  // },
  // {
  //   key: 'password',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Şifre',
  //   defaultValue: '',
  // },
  // {
  //   key: 'software',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Yazılım',
  //   defaultValue: '',
  // },
  // {
  //   key: 'softwareVersion',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Yazılım Versiyonu',
  //   defaultValue: '',
  // },
];
